"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _react = _interopRequireDefault(require("react"));
var _isArray = _interopRequireDefault(require("lodash/isArray"));
var _isString = _interopRequireDefault(require("lodash/isString"));
var _trim = _interopRequireDefault(require("lodash/trim"));
var _curry = _interopRequireDefault(require("curry"));
var _count = _interopRequireDefault(require("./count"));
var reactFlatten = (0, _curry.default)(function (children) {
  var flattenedChildren = [];
  _react.default.Children.forEach(children, function (child) {
    if (!child) return;
    if ((0, _isString.default)(child) && (0, _count.default)((0, _trim.default)(child)) < 1) return;
    if ((0, _isArray.default)(child)) {
      flattenedChildren = [].concat((0, _toConsumableArray2.default)(flattenedChildren), (0, _toConsumableArray2.default)(reactFlatten(child)));
    } else if (child.type === _react.default.Fragment) {
      flattenedChildren = [].concat((0, _toConsumableArray2.default)(flattenedChildren), (0, _toConsumableArray2.default)(reactFlatten(child.props.children)));
    } else {
      flattenedChildren = [].concat((0, _toConsumableArray2.default)(flattenedChildren), [child]);
    }
  });
  return flattenedChildren;
});
var _default = reactFlatten;
exports.default = _default;